import Modal from "./Modal.js";
import Data from "./Data.js";
import {
    calculateProgress, capitalize,
    dateFormat, getBlock, getOrderedCategories, isValidEmail, numberFormat, renderBEerrors, renderFEerrors, showSnackbar
} from "./Utils.js";
import Renders from "./Renders.js";

export default class ModalActions
{
    constructor() {
        this.data = new Data();

        document.addEventListener('click', e => {
            const target = e.target;

            if (
                (
                    target.closest('.planner-card__line .line-budget') ||
                    target.closest('.dashboard-card__stats') ||
                    target.closest('.dashboard-card__content') ||
                    target.closest('.scrollable-table .icon--eye') ||
                    target.closest('.grid__cell--actual')
                ) && !target.closest('[data-transactions="0"]')
            ) {
                const categoryId = target.closest('[data-category-id]').dataset.categoryId;
                const year = target.closest('[data-year]').dataset.year;
                const month = target.closest('[data-month]').dataset.month;

                this.transactions(categoryId, year, month);
            }

            if (target.closest('.calendar__item')) {
                const calendarItem = target.closest('.calendar__item');
                if (!calendarItem.classList.contains('calendar__item--upcoming')) {
                    this.specificTransaction(calendarItem.dataset.id);
                } else {
                    this.specificScheduledTransaction(calendarItem.dataset.id);
                }
            }

            if (target.closest('.grid__cell--max-tx')) {
                const item = target.closest('.grid__cell--max-tx');

                if (item.dataset.id) {
                    this.specificTransaction(target.closest('.grid__cell--max-tx').dataset.id);
                }
            }

            if (target.closest('.scheduled-transaction-details')) {
                this.specificScheduledTransaction(target.closest('.grid__row').dataset.id);
            }

            if (target.closest('.planner-card__line button') || target.closest('.scrollable-table .num .mask')) {
                this.changeBudget(target);
            }

            if (target.closest('.dropdown__item.delete') && target.closest('.notes-container')) {
                this.deleteNote(target);
            }

            if (target.closest('.dropdown__item.edit') && target.closest('.notes-container')) {
                this.editNote(target);
            }

            if (target.closest('.move-to')) {
                this.moveTo(target);
            }

            if (target.closest('.modal-note') || target.matches('.modal-note')) {
                this.addNote(target);
            }

            if (target.closest('.modal-add-stash') || target.matches('.modal-add-stash')) {
                this.addStash(target);
            }

            if (target.matches('#update-security-delete-account')) {
                this.deleteAccount(target);
            }

            if (target.closest('.archive') && target.closest('.dropdown--options') && target.closest('.feature-pages-categories-categories_builder')) {
                this.archive(target);
            }

            if (target.closest('.delete') && target.closest('.dropdown--options') && target.closest('.feature-pages-categories-categories_builder')) {
                this.deleteCategory(target);
            }

            if (target.closest('#transaction-delete')) {
                this.deleteTransaction(target);
            }

            if (target.closest('#scheduled-transaction-delete')) {
                this.deleteScheduledTransaction(target);
            }

            if (target.closest('#space-delete')) {
                this.deleteSpace(target);
            }

            if (target.closest('#template-delete')) {
                this.deleteTemplate(target);
            }

            if (target.closest('#create-transaction-template')) {
                this.createTransactionTemplate(target);
            }

            if (target.closest('#create-transaction-from-template')) {
                this.createTransactionFromTemplate(target);
            }

            if (target.closest('.feature-pages-categories-categories_builder') && (target.closest('.add-group') || target.closest('.add-category') || target.closest('.edit'))) {
                this.category(target);
            }

            if (target.matches('#space-scheduled-for-deletion-details') || target.closest('#space-scheduled-for-deletion-details')) {
                this.spaceScheduledForDeletionInfo(target);
            }

            if (target.closest('.btn-add-faq')) {
                this.addFAQ(target);
            }

            if (target.closest('.btn-edit-faq')) {
                this.editFAQ(target);
            }

            if (target.closest('.btn-delete-faq')) {
                this.deleteFAQ(target);
            }

            if (target.closest('[data-modal-help]')) {
                this.modalHelp(target);
            }
        });
    }

    category(target) {
        const el = target.closest('.dropdown__item ');
        const elClassList = el?.classList;
        const row = el?.closest('.placeholder__row');
        const container = target.closest('.container');
        const placeholder = container.querySelector('.card__box');

        let action = 'category';
        let text = null;
        let color = null;

        if (elClassList?.contains('edit')) {
            action = 'edit';
        } else if (elClassList?.contains('add-group') || !elClassList) {
            action = 'group';
        }

        let title = __('categories.title_edit_category');

        if (action === 'group') {
            title = __('categories.title_add_category_group');
        } else if (action === 'category') {
            title = __('categories.title_add_category');
        }

        if (action === 'edit') {
            text = row.querySelector('.text').innerText.trim();
            color = row.dataset.color;
        }

        const modal = new Modal('confirm,modal--medium-size');
        modal.onOpen('category-template', (body, signal) => {
            const successBtn = body.querySelector('.button--success');
            const closeBtn = body.querySelector('#modal-close');
            closeBtn.textContent = __('cta_close');
            successBtn.textContent = __('cta_create');
            const input = body.querySelector('input');
            const colorInput = body.querySelector('#color');

            if (text) {
                input.value = text;
                successBtn.textContent = __('cta_edit');
            }

            const inputOriginalValue = input.value;

            if (color) {
                colorInput.value = color;
                body.querySelector('#color-circle').style.backgroundColor = color;
                body.querySelector('#color-circle').classList.remove('chromatic-bloom');
                body.querySelector('#color-picker').value = color;
            }

            input.addEventListener('input', e => {
                if (input.value.trim().length) {
                    input.value = capitalize(input.value);

                    successBtn.classList.remove('button--disabled');
                } else {
                    successBtn.classList.add('button--disabled');
                }
            });

            colorInput.addEventListener('input', e => {
                if (row?.dataset?.color !== colorInput.value && input.value.trim().length) {
                    successBtn.classList.remove('button--disabled');
                } else {
                    if (inputOriginalValue === input.value.trim()) {
                        successBtn.classList.add('button--disabled');
                    }
                }
            });

            successBtn.addEventListener('click', () => {
                let position = 1;
                let realDepth = 1;

                if (row) {
                    position = row.closest('.card__box').querySelectorAll('[data-parent-id="' + row.dataset.id + '"][data-depth="' + (parseInt(row.dataset.depth) + 1) + '"]').length + 1;
                    realDepth = parseInt(row.dataset.depth) + 1;
                } else {
                    position = placeholder.closest('.card__box').querySelectorAll('[data-parent-id=""][data-depth="0"]').length + 1;
                }

                let payload = {
                    text: body.querySelector('input').value.trim(),
                    position: position,
                    action: action,
                    depth: realDepth,
                    color: colorInput.value,
                    type: (window.location.href.includes('income') ? 'income' : 'expense'),
                    parent_id: (!row ? null : row.dataset.id)
                };

                if (action === 'edit') {
                    payload.id = row.dataset.id;
                }

                this.data.editCategory(payload).then((result) => {
                    if (result.status === 'success' && !result.error) {
                        modal.close();
                        let msg = __('categories.text_new_category_created_successful');

                        if (action === 'group') {
                            msg = __('categories.text_new_category_group_created_successful');
                        } else if (action === 'edit') {
                            msg = __('text_saved_successful');
                        }

                        if (action === 'group' && placeholder.classList.contains('hide-element')) {
                            container.querySelector('.no_results')?.classList.add('hide-element');
                            placeholder.classList.remove('hide-element');
                        }

                        if (action !== 'edit') {
                            let newElement;

                            if (!row) {
                                newElement = document.getElementById('category-placeholder-row-skeleton-template').content.firstElementChild.cloneNode(true);
                            } else {
                                newElement = row.cloneNode(true);
                            }

                            __All(newElement);

                            newElement.querySelector('.text').innerText = payload.text;
                            newElement.dataset.id = result.data.id;
                            newElement.dataset.parentId = (payload.parent_id ? payload.parent_id : '');
                            newElement.dataset.position = payload.position;
                            newElement.dataset.transactions = 0;
                            newElement.dataset.depth = (!row ? 0 : parseInt(row.dataset.depth) + 1);
                            newElement.style.setProperty('--depth', newElement.dataset.depth);

                            if (result.data.color) {
                                newElement.dataset.color = result.data.color;
                                newElement.style.setProperty('--row-color', result.data.color);
                            } else {
                                newElement.dataset.color = '';
                                newElement.style.removeProperty('--row-color');
                            }

                            newElement.classList.remove('placeholder__row--category', 'placeholder__row--container');

                            if (payload.action === 'category') {
                                newElement.classList.add('placeholder__row--category');

                                newElement.querySelector('.dropdown__item.add-category').remove();
                                newElement.querySelector('.dropdown__item.add-group').remove();
                            } else {
                                newElement.classList.add('placeholder__row--container');
                            }

                            newElement.className = newElement.className.replace(/placeholder__row--depth-[0-9]+/g,'').trim();
                            newElement.classList.add('placeholder__row--depth-' + newElement.dataset.depth);

                            if (!row) {
                                document.querySelector('.card__content').appendChild(newElement);
                            } else {
                                const parentDepth = parseInt(row.dataset.depth);
                                const container = row.closest('.card__content');
                                const rows = Array.from(container.querySelectorAll('.placeholder__row'));
                                const rowsLength = rows.length;

                                const parentIndex = rows.indexOf(row);
                                let requiredPoint = row;

                                for (let i = parentIndex + 1; i < rowsLength; ++i) {
                                    const currentRow = rows[i];
                                    const currentRowDepth = parseInt(currentRow.dataset.depth);

                                    if (currentRowDepth <= parentDepth) {
                                        break;
                                    }

                                    requiredPoint = currentRow;
                                }

                                requiredPoint.insertAdjacentElement('afterend', newElement);
                            }
                        } else {
                            if (result.data.color) {
                                row.dataset.color = result.data.color;
                                row.style.setProperty('--row-color', result.data.color);
                            } else {
                                row.dataset.color = '';
                                row.style.removeProperty('--row-color');
                            }

                            row.querySelector('.text').innerText = payload.text;
                        }

                        showSnackbar(msg, 'success');
                    } else {
                        renderBEerrors(body.querySelector('form'), result.data);
                    }
                });
            }, {signal});
        });

        modal.open(title);
    }

    createTransactionFromTemplate(target) {
        const modal = new Modal('confirm,modal--medium-size');
        modal.onOpen('confirm-template', (body, signal) => {
            const closeBtn = body.querySelector('#modal-close');
            closeBtn.textContent = __('cta_close');
            const successBtn = body.querySelector('.button--success');
            successBtn.classList.remove('button--disabled');
            successBtn.textContent = __('cta_yes');

            body.querySelector('p').textContent = __('transactions.text_new_transaction_based_on_template');

            successBtn.addEventListener('click', () => {
                this.data.createTransactionFromTemplate(target.closest('[data-id]').dataset.id).then((result) => {
                    modal.close();

                    if (result.status === 'success' && !result.error) {
                        showSnackbar(__('transactions.text_transaction_was_created_successful'), 'success');
                    }
                });
            }, {signal});
        });

        modal.open(__('transactions.title_use_this_template'));
    }

    createTransactionTemplate(target) {
        if (typeof BS_EVENTS.active_modal !== "undefined") {
            BS_EVENTS.active_modal.close();
        }

        const modal = new Modal('confirm,modal--medium-size');
        modal.onOpen('tx-tmp-template', (body, signal) => {
            const closeBtn = body.querySelector('#modal-close');
            closeBtn.textContent = __('cta_close');
            const createBtn = body.querySelector('.button--success');
            const name = body.querySelector('#name');
            createBtn.textContent = __('cta_create');

            name.focus();

            name.addEventListener('input', e => {
                if (name.value.trim().length) {
                    createBtn.classList.remove('button--disabled');
                } else {
                    createBtn.classList.add('button--disabled');
                }
            });

            createBtn.addEventListener('click', () => {
                this.data.newTransactionTemplate({name: name.value, transaction_id: target.closest('[data-id]').dataset.id}).then((result) => {
                    modal.close();

                    if (result.status === 'success' && !result.error) {
                        showSnackbar(__('transaction_templates.text_created_successful'), 'success');
                    }
                });
            }, {signal});
        });

        modal.open(__('transaction_templates.title_new_template'));
    }

    deleteCategory(target) {
        const modal = new Modal('confirm,modal--medium-size');
        modal.onOpen('confirm-template', (body, signal) => {
            const closeBtn = body.querySelector('#modal-close');
            closeBtn.textContent = __('cta_close');
            const deleteBtn = body.querySelector('.button--success');
            deleteBtn.classList.replace('button--success', 'button--danger');
            deleteBtn.classList.remove('button--disabled');
            deleteBtn.textContent = __('cta_delete');

            const container = target.closest('.container');

            body.querySelector('p').textContent = __('categories.text_deleting_this_category');

            deleteBtn.addEventListener('click', () => {
                this.data.deleteCategory(target.closest('.placeholder__row').dataset.id).then((result) => {
                    modal.close();

                    if (result.status === 'success' && !result.error) {
                        target.closest('.placeholder__row').remove();

                        if (!container.querySelectorAll('.placeholder__row').length) {
                            container.querySelector('.card__box').classList.add('hide-element');
                            container.querySelector('.no_results').classList.remove('hide-element');
                        }

                        showSnackbar(__('categories.text_category_deleted_successful'), 'success');
                    }
                });
            }, {signal});
        });

        modal.open(__('title_are_you_sure'));
    }

    archive(target) {
        const modal = new Modal('archive,modal--medium-size');
        modal.onOpen('archive-template', (body, signal) => {
            const closeBtn = body.querySelector('#modal-close');
            closeBtn.textContent = __('cta_close');
            const archiveBtn = body.querySelector('.button--success');
            archiveBtn.classList.replace('button--success', 'button--warning');
            archiveBtn.classList.remove('button--disabled');
            archiveBtn.textContent = __('categories.cta_archive');

            body.querySelector('p').textContent = __('categories.text_archive');

            const date = new Date();
            const yearsDropdown = body.querySelector('input#year').closest('.dropdown');
            const yearsDropdownContent = yearsDropdown.querySelector('.dropdown__content');
            const yearsDropdownItem = yearsDropdown.querySelector('.dropdown__item');
            const yearsDropdownItemTemplate = yearsDropdownItem.cloneNode(true);
            yearsDropdownItem.remove();

            yearsDropdown.querySelector('.dropdown__selected .text').innerText = date.getFullYear();
            yearsDropdown.querySelector('input#year').value = date.getFullYear();

            const startDate = new Date();
            const startYear = startDate.getFullYear();
            const endYear = date.getFullYear() + 30;

            for (let year = startYear; year <= endYear; ++year) {
                const child = yearsDropdownItemTemplate.cloneNode(true);
                child.dataset.value = year;
                child.querySelector('.text').textContent = year;

                yearsDropdownContent.appendChild(child);
            }

            const monthsDropdown = body.querySelector('input#month').closest('.dropdown');
            const monthsDropdownContent = monthsDropdown.querySelector('.dropdown__content');
            const monthsDropdownItem = monthsDropdown.querySelector('.dropdown__item');
            const monthsDropdownItemTemplate = monthsDropdownItem.cloneNode(true);
            monthsDropdownItem.remove();

            monthsDropdown.querySelector('.dropdown__selected .text').innerText = __('month_' + MONTHS[date.getMonth()].toLowerCase());
            monthsDropdown.querySelector('input#month').value = date.getMonth() + 1;

            for (let i = 0; i < 12; ++i) {
                const child = monthsDropdownItemTemplate.cloneNode(true);

                if (i < startDate.getMonth()) {
                    child.classList.add('dropdown__item--inactive');
                }

                child.dataset.value = i + 1;
                child.querySelector('.text').textContent = __('month_' + MONTHS[i].toLowerCase());

                monthsDropdownContent.appendChild(child);
            }

            yearsDropdown.addEventListener('click', e => {
                if (e.target.closest('.dropdown__item')) {
                    const selectedItem = e.target.closest('.dropdown__item');

                    if (parseInt(selectedItem.dataset.value) !== startDate.getFullYear()) {
                        monthsDropdown.querySelectorAll('.dropdown__item').forEach(ddItem => ddItem.classList.remove('dropdown__item--inactive'));
                    } else {
                        monthsDropdown.querySelectorAll('.dropdown__item').forEach(ddItem => {
                            const currentMonth = startDate.getMonth() + 1;
                            if (parseInt(ddItem.dataset.value) < currentMonth) {
                                ddItem.classList.add('dropdown__item--inactive');
                            }
                        });

                        monthsDropdown.querySelector('.dropdown__selected span').textContent = monthsDropdown.querySelector('.dropdown__item:not(.dropdown__item--inactive) span').textContent;
                    }
                }
            }, {signal});

            archiveBtn.addEventListener('click', () => {
                const payload = {
                    category_id: target.closest('.placeholder__row').dataset.id,
                    year: yearsDropdown.querySelector('input#year').value,
                    month: monthsDropdown.querySelector('input#month').value
                };

                this.data.archive(payload).then((result) => {
                    modal.close();

                    if (result.status === 'success' && !result.error) {
                        target.closest('.placeholder__row').classList.add('inactive-element');
                        let successMessage = __('categories.text_category_archived');

                        if (payload.year > date.getFullYear() || payload.year === date.getFullYear() && payload.month > (date.getMonth() + 1)) {
                            successMessage = __('categories.text_category_scheduled_for_archive');
                        }

                        showSnackbar(successMessage, 'success');
                    }
                });
            }, {signal});
        });

        modal.open(__('title_are_you_sure'));
    }

    addNote(target) {
        const modal = new Modal('note,modal--medium-size');
        modal.onOpen('note-template', (body, signal) => {
            const textarea = body.querySelector('textarea');
            const input = body.querySelector('input');
            const cancelBtn = body.querySelector('#modal-close');
            const saveBtn = body.querySelector('.button--success');
            saveBtn.textContent = __('cta_create');
            cancelBtn.textContent = __('cta_cancel');

            textarea.addEventListener('input', e => {
                if (textarea.value.trim().length) {
                    saveBtn.classList.remove('button--disabled');
                } else {
                    saveBtn.classList.add('button--disabled');
                }
            });

            saveBtn.addEventListener('click', () => {
                this.data.addNote(textarea.value.trim(), input.value.trim()).then((result) => {
                    modal.close();

                    if (result.status === 'success' && !result.error) {
                        if (document.body.classList.contains('feature-pages-notes-note')) {
                            const cardBox = document.getElementById('note-skeleton-template').content.firstElementChild.cloneNode(true);
                            cardBox.dataset.id = result.data[0].id;
                            cardBox.querySelector('.card__content').textContent = result.data[0].text;
                            cardBox.querySelector('.card__footer span:first-child').textContent = dateFormat(result.data[0].created_at);
                            cardBox.closest('.card__box').querySelector('.card__info .text').dataset.tooltip = input.value.trim();
                            cardBox.closest('.card__box').querySelector('.card__info .text').textContent = input.value.trim();

                            document.querySelector('.notes-container .no_results').classList.add('hide-element');

                            __All(cardBox);
                            document.querySelector('.notes-container').prepend(cardBox);
                        }
                        showSnackbar(__('notes.text_note_added_successful'), 'success');
                    }
                });
            }, {signal});
        });

        modal.open(__('notes.title_creating_new_note'));
    }

    addStash(target) {
        const modal = new Modal('note,modal--medium-size');
        modal.onOpen('stash-template', (body, signal) => {
            const cancelBtn = body.querySelector('#modal-close');
            const saveBtn = body.querySelector('.button--success');
            saveBtn.textContent = __('cta_create');
            cancelBtn.textContent = __('cta_cancel');
            //
            // textarea.addEventListener('input', e => {
            //     if (textarea.value.trim().length) {
            //         saveBtn.classList.remove('button--disabled');
            //     } else {
            //         saveBtn.classList.add('button--disabled');
            //     }
            // });
            //
            // saveBtn.addEventListener('click', () => {
            //     this.data.addNote(textarea.value.trim(), input.value.trim()).then((result) => {
            //         modal.close();
            //
            //         if (result.status === 'success' && !result.error) {
            //             if (document.body.classList.contains('feature-pages-notes-note')) {
            //                 const cardBox = document.getElementById('note-skeleton-template').content.firstElementChild.cloneNode(true);
            //                 cardBox.dataset.id = result.data[0].id;
            //                 cardBox.querySelector('.card__content').textContent = result.data[0].text;
            //                 cardBox.querySelector('.card__footer span:first-child').textContent = dateFormat(result.data[0].created_at);
            //                 cardBox.closest('.card__box').querySelector('.card__info .text').dataset.tooltip = input.value.trim();
            //                 cardBox.closest('.card__box').querySelector('.card__info .text').textContent = input.value.trim();
            //
            //                 document.querySelector('.notes-container .no_results').classList.add('hide-element');
            //
            //                 __All(cardBox);
            //                 document.querySelector('.notes-container').prepend(cardBox);
            //             }
            //             showSnackbar(__('notes.text_note_added_successful'), 'success');
            //         }
            //     });
            // }, {signal});
        });

        modal.open(__('notes.title_creating_new_note'));
    }

    editNote(target) {
        const modal = new Modal('note,modal--medium-size');
        modal.onOpen('note-template', (body, signal) => {
            const closeBtn = body.querySelector('#modal-close');
            closeBtn.textContent = __('cta_close');
            const input = body.querySelector('input');
            const textarea = body.querySelector('textarea');
            const originalValue = target.closest('.card__box').querySelector('.card__content').textContent;
            const originalNameValue = target.closest('.card__box').querySelector('.card__info .text').textContent;
            const saveBtn = body.querySelector('.button--success');
            saveBtn.textContent = __('cta_save');
            textarea.value = originalValue;
            input.value = originalNameValue;

            body.addEventListener('input', e => {
                if (
                    input.value.trim() !== originalNameValue
                    ||
                    textarea.value.trim() !== originalValue && textarea.value.trim().length
                ) {
                    saveBtn.classList.remove('button--disabled');
                } else {
                    saveBtn.classList.add('button--disabled');
                }
            });

            saveBtn.addEventListener('click', () => {
                this.data.editNote(target.closest('.card__box').dataset.id, textarea.value.trim(), body.querySelector('input#name').value.trim()).then((result) => {
                    modal.close();

                    if (result.status === 'success' && !result.error) {
                        target.closest('.card__box').querySelector('.card__content').textContent = textarea.value.trim();
                        target.closest('.card__box').querySelector('.card__info .text').dataset.tooltip = input.value.trim();
                        target.closest('.card__box').querySelector('.card__info .text').textContent = input.value.trim();
                        showSnackbar(__('text_saved_successful'), 'success');
                    }
                });
            }, {signal});
        });

        modal.open(__('notes.title_edit_note'));
    }

    deleteTemplate(target) {
        const modal = new Modal('confirm,modal--medium-size');
        modal.onOpen('confirm-template', (body, signal) => {
            const closeBtn = body.querySelector('#modal-close');
            closeBtn.textContent = __('cta_close');
            const deleteBtn = body.querySelector('.button--success');
            const section = target.closest('.section');
            deleteBtn.classList.replace('button--success', 'button--danger');
            deleteBtn.classList.remove('button--disabled');
            deleteBtn.textContent = __('cta_delete');

            body.querySelector('p').textContent = __('transaction_templates.text_delete');

            deleteBtn.addEventListener('click', () => {
                this.data.deleteTemplate(section.dataset.id,section.querySelector('input[name="position"]').value).then((result) => {
                    modal.close();

                    if (result.status === 'success' && !result.error) {
                        showSnackbar(__('transaction_templates.text_deleted_successful'), 'success', '/' + SYSTEM_LANGUAGE + '/transaction-templates');
                    }
                });
            }, {signal});
        });

        modal.open(__('title_are_you_sure'));
    }

    deleteTransaction(target) {
        const modal = new Modal('confirm,modal--medium-size');
        modal.onOpen('confirm-template', (body, signal) => {
            const deleteBtn = body.querySelector('.button--success');
            const cancelBtn = body.querySelector('#modal-close');
            deleteBtn.classList.replace('button--success', 'button--danger');
            deleteBtn.classList.remove('button--disabled');
            deleteBtn.textContent = __('cta_delete');
            cancelBtn.textContent = __('cta_cancel');

            body.querySelector('p').textContent = __('transactions.text_delete_this_transaction');

            deleteBtn.addEventListener('click', () => {
                this.data.deleteTransaction(target.closest('.section').dataset.id).then((result) => {
                    modal.close();

                    if (result.status === 'success' && !result.error) {
                        showSnackbar(__('transactions.text_deleted_successful'), 'success', '/' + SYSTEM_LANGUAGE + '/transactions');
                    }
                });
            }, {signal});
        });

        modal.open(__('title_are_you_sure'));
    }

    deleteScheduledTransaction(target) {
        const modal = new Modal('confirm,modal--medium-size');
        modal.onOpen('confirm-template', (body, signal) => {
            const deleteBtn = body.querySelector('.button--success');
            const cancelBtn = body.querySelector('#modal-close');
            cancelBtn.textContent = __('cta_cancel');
            deleteBtn.classList.replace('button--success', 'button--danger');
            deleteBtn.classList.remove('button--disabled');
            deleteBtn.textContent = __('cta_delete');

            body.querySelector('p').textContent = __('scheduled_transactions.text_delete_this_scheduled_transaction');

            deleteBtn.addEventListener('click', () => {
                this.data.deleteScheduledTransaction(target.closest('.section').dataset.id).then((result) => {
                    modal.close();

                    if (result.status === 'success' && !result.error) {
                        showSnackbar(__('scheduled_transactions.text_deleted_successful'), 'success', '/' + SYSTEM_LANGUAGE + '/scheduled-transactions');
                    }
                });
            }, {signal});
        });

        modal.open(__('title_are_you_sure'));
    }

    deleteAccount(target) {
        const modal = new Modal('confirm,modal--medium-size');
        modal.onOpen('confirm-template', (body, signal) => {
            const deleteBtn = body.querySelector('.button--success');
            const cancelBtn = body.querySelector('#modal-close');
            cancelBtn.textContent = __('cta_cancel');
            deleteBtn.classList.replace('button--success', 'button--danger');
            deleteBtn.textContent = __('cta_confirm');

            body.querySelector('p').textContent = __('account.text_deleting_account');

            body.querySelector('p').insertAdjacentHTML('afterend', `
                <form id="delete__form" novalidate="">
                     <div class="form__group hide-element">
                        <label for="username">username</label>
                        <input type="text" class="input" id="username" autocomplete="yes"/>
                        <span class="error" data-field="username"></span>
                    </div>
                    <div class="form__group">
                        <label for="password">${__('account.label_confirm_your_password')}</label>
                                                
                        <div class="icon__field icon__field--password">
                            <input type="password" id="password" class="input" name="password" autocomplete="current-password" placeholder="••••••••" maxlength="30"/>
                            <button type="button" class="toggle-eye" aria-label="<?= __('label_show_password', $i18n) ?>">
                                <span class="icon icon--eye" aria-hidden="true"></span>
                            </button>
                        </div>
                        
                        <span class="error" data-field="password"></span>
                    </div>
                </form>            
            `);

            body.addEventListener('input', e => {
                if (e.target.value.trim().length) {
                    deleteBtn.classList.remove('button--disabled');
                } else {
                    deleteBtn.classList.add('button--disabled');
                }
            }, {signal});

            deleteBtn.addEventListener('click', () => {
                this.data.deleteAccount(body.querySelector('input#password').value).then((response) => {
                    if (response.status === 'success' && !response.error) {
                        showSnackbar(__('account.text_account_scheduled_for_deletion'), 'success');
                        const container = target.closest('.container');
                        const p = container.querySelector('#restore_account_placeholder p');

                        p.innerHTML = p.innerHTML.replace('{date}', dateFormat(response.data));

                        container.querySelector('#delete_account_placeholder').classList.add('hide-element');
                        container.querySelector('#restore_account_placeholder').classList.remove('hide-element');
                        modal.close();
                    } else {
                        renderBEerrors(body.querySelector('#delete__form'), response.data);
                    }
                });
            }, {signal});
        });

        modal.open(__('title_are_you_sure'));
    }

    deleteNote(target) {
        const modal = new Modal('confirm,modal--medium-size');
        modal.onOpen('confirm-template', (body, signal) => {
            const deleteBtn = body.querySelector('.button--success');
            const cancelBtn = body.querySelector('#modal-close');
            deleteBtn.classList.replace('button--success', 'button--danger');
            deleteBtn.classList.remove('button--disabled');
            deleteBtn.textContent = __('cta_delete');
            cancelBtn.textContent = __('cta_cancel');

            body.querySelector('p').textContent = __('notes.text_deleting_this_note');
            
            deleteBtn.addEventListener('click', () => {
                this.data.deleteNote(target.closest('.card__box').dataset.id).then((result) => {
                    modal.close();

                    if (result.status === 'success' && !result.error) {
                        target.closest('.card__box').remove();
                        showSnackbar(__('notes.text_note_deleted_successful'), 'success');

                        const notesContainer = document.querySelector('.notes-container');
                        if (!notesContainer.querySelectorAll('.card__box').length) {
                            notesContainer.querySelector('.no_results').classList.remove('hide-element');
                        }
                    }
                });
            }, {signal});
        });

        modal.open(__('title_are_you_sure'));
    }

    changeBudget(target) {
        const modal = new Modal('change-budget,modal--medium-size');
        const isCompactView = target.closest('#compact_view');

        const categoryId = target.closest('[data-category-id]').dataset.categoryId;
        const month = target.closest('[data-month]').dataset.month;

        let selectedMonth = isCompactView ?
            target.closest('.planner-card__line').querySelector('.line-month').textContent :
            target.closest('.card__content').querySelector('[data-header-month="' + month + '"]').textContent;

        const compactViewTarget = !isCompactView ? target.closest('.container').querySelector('#compact_view [data-category-id="' + categoryId + '"] [data-month="' + month + '"] .icon--edit') : target;

        modal.onOpen('change-budget-template', (body, signal) => {
            let categories = [];
            const form = body.querySelector('form');
            const saveBtn = body.querySelector('.button--success');
            const cancelBtn = body.querySelector('#modal-close');
            const type = compactViewTarget.closest('[data-type]').dataset.type;

            const group = compactViewTarget.closest('.planner-card');
            const row = compactViewTarget.closest('.planner-card__line');
            const budgetField = body.querySelector('#budget');

            cancelBtn.textContent = __('cta_cancel');
            saveBtn.textContent = __('cta_save');

            group.querySelectorAll('.planner-card__title span').forEach(cat => categories.push(cat.textContent));
            categories.reverse();

            budgetField.value = row.dataset.amount;
            budgetField.focus();
            body.querySelector('#category').value = categories.join(JOINING_SYMBOL);

            body.querySelector('#budget').addEventListener('input', e => {
                if (!/^\d+([\.,]\d+)?$/.test(e.target.value)) {
                    renderFEerrors(form, {budget: __('error_enter_numeric_amount')});
                    saveBtn.classList.add('button--disabled');
                } else {
                    const field = e.target.closest('.form__group');
                    field.classList.remove('form__group--error');
                    field.querySelector('.error').textContent = '';
                    saveBtn.classList.remove('button--disabled');
                }
            }, {signal});

            body.querySelector('#following').addEventListener('change', e => {
                if (e.target.checked) {
                    saveBtn.classList.remove('button--disabled');
                } else {
                    if (row.dataset.amount === body.querySelector('#budget').value) {
                        saveBtn.classList.add('button--disabled');
                    }
                }
            }, {signal});

            saveBtn.addEventListener('click', e => {
                const newBudget = parseFloat(body.querySelector('#budget').value.replace(',','.'));
                const followingMonths = body.querySelector('#following:checked');
                const categoryId = group.dataset.categoryId;
                const year = compactViewTarget.closest('[data-year]').dataset.year;
                const month = parseInt(row.dataset.month);
                let oldValues = {};

                if (followingMonths) {
                    group.querySelectorAll('.planner-card__line').forEach(item => {
                        if (parseInt(item.dataset.month) > month) {
                            oldValues[item.dataset.month] = item.dataset.actual;
                        }
                    });
                }

                const payload = {
                    amount: newBudget,
                    category_id: categoryId,
                    year,
                    month,
                    repeat_to_following_months: !!followingMonths,
                    old_values: oldValues
                }

                this.data.updateBudget(payload).then((results) => {
                    modal.close();

                    if (results.status === 'success' && !results.error) {
                        const oldAmount = parseFloat(row.dataset.amount);
                        const newAmount = parseFloat(payload.amount);
                        const monthIndex = Number(payload.month) - 1;

                        EXTRA_DATA.planner.budget[monthIndex] += newAmount - oldAmount;

                        if (followingMonths && Object.keys(oldValues).length) {
                            Object.entries(oldValues).forEach(([month, oldValue]) => {
                                const monthIndex = Number(month) - 1;
                                EXTRA_DATA.planner.budget[monthIndex] += newAmount - parseFloat(oldValue);
                            });
                        }

                        window.dispatchEvent(new Event('budgetChanged'));

                        showSnackbar(__('text_saved_successful'), 'success');
                        row.dataset.amount = newBudget;

                        const budgetElement = row.querySelector('.line-budget');

                        let { additionalClass, tooltipText } = this.checkBudgetState(type, newBudget, parseFloat(row.dataset.actual));
                        budgetElement.classList.remove('negative', 'positive');

                        if (additionalClass.length) {
                            budgetElement.classList.add(additionalClass);
                        }

                        budgetElement.textContent = numberFormat(newBudget);
                        budgetElement.dataset.tooltip = tooltipText;

                        const fullView = target.closest('.container').querySelector('#full_view');
                        if (fullView) {
                            const fullViewCell = fullView.querySelector('[data-category-id="' + categoryId + '"] [data-month="' + month + '"]');
                            const fullViewCellIndex = fullViewCell.cellIndex;
                            const fullViewRow = fullViewCell.closest('tr');
                            const fullViewTable = fullViewCell.closest('table');

                            fullViewCell.dataset.amount = newBudget;
                            fullViewCell.querySelector('.mask').dataset.tooltip = tooltipText;
                            fullViewCell.classList.remove('negative', 'positive');

                            if (additionalClass.length) {
                                fullViewCell.classList.add(additionalClass);
                            }

                            fullViewCell.querySelector('.mask').textContent = numberFormat(newBudget);

                            if (followingMonths) {
                                fullViewRow.querySelectorAll('td').forEach(item => {
                                    if (parseFloat(item.dataset.month) > parseFloat(month)) {
                                        item.dataset.amount = newBudget;
                                        const itemBudget = item.querySelector('.mask');

                                        let { additionalClass, tooltipText } = this.checkBudgetState(type, newBudget, parseFloat(item.dataset.actual));
                                        itemBudget.classList.remove('negative', 'positive');

                                        if (additionalClass.length) {
                                            itemBudget.classList.add(additionalClass);
                                        }

                                        itemBudget.textContent = numberFormat(newBudget);

                                        itemBudget.dataset.tooltip = tooltipText;
                                    }
                                });
                            }

                            // update horizontal total
                            let totalAmount = 0;
                            fullViewRow.querySelectorAll('td[data-active-amount="1"]').forEach(item => totalAmount += parseFloat(item.dataset.amount ?? 0));
                            fullViewRow.querySelector('.yearly_totals .total_budget').textContent = numberFormat(totalAmount);

                            // update vertical totals

                            const allRows = Array.from(fullViewTable.querySelectorAll('tr'));
                            const startColumnIndex = fullViewCellIndex;
                            const maxColumnIndex = fullViewRow.querySelectorAll('td').length - 1;
                            const endColumnIndex = followingMonths ? maxColumnIndex : fullViewCellIndex;

                            for (let columnIndex = startColumnIndex; columnIndex <= endColumnIndex; ++columnIndex) {
                                let totalVerticalAmount = 0;

                                const columnCells = allRows.map(r => r.cells[columnIndex]).filter(Boolean);

                                columnCells.forEach(cell => {
                                    if (Number(cell.dataset.activeAmount)) {
                                        const foundAmount = cell.querySelector('.num .mask');
                                        if (foundAmount) {
                                            totalVerticalAmount += parseFloat(cell.dataset.amount ?? 0);
                                        }
                                    }
                                });

                                const lastCell = columnCells[columnCells.length - 1];
                                lastCell.dataset.amount = totalVerticalAmount;
                                lastCell.querySelector('.total_budget').textContent = numberFormat(totalVerticalAmount);
                            }

                            // update yearly total
                            let yearlyTotal = 0;
                            fullViewTable.querySelectorAll('tr:last-child td:not(:last-child)').forEach(item => {
                                yearlyTotal += parseFloat(item.dataset.amount ?? 0);
                            });

                            fullViewTable.querySelector('tr:last-child td:last-child .total_budget').textContent = numberFormat(yearlyTotal);
                        }

                        if (followingMonths) {
                            group.querySelectorAll('.planner-card__line').forEach(line => {
                                if (parseFloat(line.dataset.month) > parseFloat(row.dataset.month)) {
                                    line.dataset.amount = newBudget;

                                    const lineBudget = line.querySelector('.line-budget');

                                    let { additionalClass, tooltipText } = this.checkBudgetState(type, newBudget, parseFloat(line.dataset.actual));
                                    lineBudget.classList.remove('negative', 'positive');

                                    if (additionalClass.length) {
                                        lineBudget.classList.add(additionalClass);
                                    }

                                    lineBudget.textContent = numberFormat(newBudget);

                                    lineBudget.dataset.tooltip = tooltipText;
                                }
                            });
                        }

                        calculateProgress(group);
                    }
                });
            }, {signal});
        });

        modal.open(__('categories.title_change_budget_for') + ' ' + selectedMonth);
    }

    checkBudgetState(type, budget, actual) {
        let additionalClass = 'secondary-text';
        let tooltipText = __('categories.label_pending');

        if (actual > 0) {
            if (actual > budget) {
                additionalClass = (type === 'expenses' ? 'negative' : 'positive');
                tooltipText = __('categories.label_over_budget') + ' ' + numberFormat(actual - budget);
            } else if (actual < budget) {
                additionalClass = (type === 'expenses' ? 'positive' : 'negative');
                tooltipText = __('categories.label_under_budget') +' ' + numberFormat(budget - actual);
            } else {
                additionalClass = '';
                tooltipText = ' ' + __('categories.label_on_budget');
            }
        }

        return { additionalClass, tooltipText }
    }

    specificScheduledTransaction(transactionId) {
        this.data.scheduledTransactionById(transactionId).then((results) => {
            this.drawScheduledTransaction(results);
        });
    }


    specificTransaction(transactionId) {
        this.data.transactionById(transactionId).then((results) => {
            this.drawTransactions(results);
        });
    }

    transactions(categoryId, year, month) {
        const payload = {
            category_id: categoryId,
            year: year,
            month: month
        };

        this.data.transactionsList(payload).then((results) => {
            this.drawTransactions(results);
        });
    }

    drawTransactions(results) {
        if (results.status === 'success' && !results.error) {

            let modalSize = 'big';

            if (Object.keys(results.data).length === 1) {
                modalSize = 'medium';
            }

            const modal = new Modal('transactions,modal--' + modalSize + '-size');

            modal.onOpen('transactions-list-template', (body) => {
                body.querySelector('.no_results')?.remove();
                body.querySelector('.button--load-more')?.remove();
                body.querySelector('.button--success')?.remove();
                body.querySelector('#modal-close').textContent = __('cta_close');

                body.querySelector('.action__bar')?.remove();

                const grid = body.querySelector('.grid__content');
                const spacesCell = Array.from(grid.closest('.grid').querySelectorAll('.grid__header span')).find(cell => cell.dataset.i18n === 'label_spaces');
                spacesCell.insertAdjacentHTML('afterend', '<span class="grid__cell--center text" data-i18n="label_created_by"></span>');

                const gridRow = grid.querySelector('.grid__row');
                gridRow.remove();

                const render = new Renders();

                for (let txId in results.data) {
                    const row = render.transaction(results.data[txId], gridRow.cloneNode(true), true, true, modalSize);

                    grid.insertAdjacentElement('beforeend', row);
                }
            });

            modal.open(__('transactions.title_transaction' + (Object.keys(results.data).length === 1 ? '' : 's')));
        }
    }

    drawScheduledTransaction(results) {
        if (results.status === 'success' && !results.error) {
            const modal = new Modal('scheduled-transactions,modal--medium-size');

            modal.onOpen('scheduled-transactions-list-template', (body) => {
                body.querySelector('.placeholder--action-bar')?.remove();
                body.querySelector('.no_results')?.remove();
                body.querySelector('.button--load-more')?.remove();
                body.querySelector('.button--success').remove();

                body.querySelector('#modal-close').textContent = __('cta_close');

                const grid = body.querySelector('.grid__content');

                // add extra fields
                // grid.querySelector('.grid__row .grid__cell--amount').insertAdjacentHTML('afterend', `<div class="grid__cell grid__cell--comment" data-i18n="label_comment" data-label=""><span class="grid__cell--empty text" data-tooltip>-</span></div>`);
                const extraFields = [
                    'Last Run at',
                    // 'Manual Runs',
                    'Auto Runs',
                    'Max Runs',
                    'Start After',
                    'Frequency Type'
                ];

                extraFields.reverse();

                extraFields.forEach(item => {
                    grid.querySelector('.grid__row .grid__cell--next-run-at').insertAdjacentHTML('afterend', `<div class="grid__cell grid__cell--${item.toLowerCase().replaceAll(' ', '-')}" data-i18n="label_${item.toLowerCase().replaceAll(' ', '_')}" data-label="${item}"><span class="grid__cell--empty text" data-tooltip>-</span></div>`)
                });

                const gridRow = grid.querySelector('.grid__row');
                gridRow.remove();

                const render = new Renders();

                for (let txId in results.data) {
                    const row = render.scheduledTransaction(results.data[txId], gridRow.cloneNode(true));

                    grid.insertAdjacentElement('beforeend', row);
                }
            });

            modal.open(__('scheduled_transactions.title_scheduled_transaction'));
        }
    }

    moveTo(target) {
        const modal = new Modal('move-to-modal,modal--medium-size');
        modal.onOpen('move-to-template', (body, signal) => {
            const placeholder = target.closest('.card__box');
            const snapshot = [...placeholder.querySelector('.card__content').children].map(i => i.cloneNode(true));
            const row = target.closest('.placeholder__row');
            const items = placeholder.querySelectorAll('.placeholder__row--container');
            const dropdownContent = body.querySelector('.dropdown__content');
            const dropdownItemTemplate = body.querySelector('.dropdown__item');
            const dropdownItem = dropdownItemTemplate.cloneNode(true);
            let selectedCategoryId;
            const getAllChildren = (parentId, rows) => {
                let children = [];

                const directChildren = rows.filter(row => row.dataset.parentId === parentId);

                for (const child of directChildren) {
                    const childId = child.dataset.id;
                    children.push(childId);

                    children = children.concat(getAllChildren(childId, rows));
                }

                return children;
            };

            dropdownItemTemplate.remove();
            body.querySelector('.dropdown__selected .text').textContent = __('categories.text_please_select_category');
            body.querySelector('p').textContent = __('categories.text_move_to');

            const toDisabled = getAllChildren(row.dataset.id, [...items]);

            if (row.classList.contains('placeholder__row--container') && row.dataset.depth > 0) {
                const ddItem = dropdownItem.cloneNode(true);
                ddItem.style.setProperty('--depth', 0);
                ddItem.querySelector('.text').textContent = 'Default';
                ddItem.classList.add('available');

                dropdownContent.append(ddItem);
            }

            items.forEach(item => {
                const ddItem = dropdownItem.cloneNode(true);
                ddItem.style.setProperty('--depth', item.dataset.depth);
                ddItem.querySelector('.text').textContent = item.querySelector('.text').textContent;
                ddItem.dataset.value = item.dataset.id;
                ddItem.dataset.id = item.dataset.id;

                const isSelf = item.dataset.id === row.dataset.id;
                const isDescendant = toDisabled.includes(item.dataset.id);
                const isCurrentParent = row.dataset.parentId === item.dataset.id;

                if (isSelf || isDescendant || isCurrentParent) {
                    ddItem.classList.add('dropdown__item--inactive');
                }

                dropdownContent.append(ddItem);
            });

            const closeBtn = body.querySelector('#modal-close');
            const successBtn = body.querySelector('.button--success');
            successBtn.classList.remove('button--disabled');
            successBtn.textContent = __('categories.cta_move');
            successBtn.classList.add('button--disabled');
            closeBtn.textContent = __('cta_close');

            body.addEventListener('click', e => {
                if (e.target.closest('.dropdown__item')) {
                    selectedCategoryId = e.target.closest('.dropdown__item').dataset.id;
                    successBtn.classList.remove('button--disabled');
                }
            }, {signal});

            successBtn.addEventListener('click', () => {
                const movingBlock = getBlock(row);
                const movingBlockLength = movingBlock.length;
                const originalRootDepth = Number(movingBlock[0].dataset.depth || 0);
                const isMovingToRoot = !selectedCategoryId;

                let targetRootDepth;
                let selectedCategoryRow;

                if (isMovingToRoot) {
                    selectedCategoryRow = placeholder.querySelector('.card__content').lastElementChild;
                    targetRootDepth = 0;
                } else {
                    selectedCategoryRow = placeholder.querySelector('[data-id="' + selectedCategoryId + '"]');
                    targetRootDepth = Number(selectedCategoryRow.dataset.depth || 0) + 1;
                }

                const depthOffset = targetRootDepth - originalRootDepth;

                movingBlock[0].dataset.parentId = selectedCategoryId || '';

                for (let z = 0; z < movingBlockLength; ++z) {
                    const currentDepth = Number(movingBlock[z].dataset.depth || 0);
                    const newDepth = currentDepth + depthOffset;

                    movingBlock[z].dataset.depth = newDepth;
                    movingBlock[z].style.setProperty('--depth', newDepth);
                }

                const siblingsFromSelectedCategory = getBlock(selectedCategoryRow);
                const targetElement = siblingsFromSelectedCategory[siblingsFromSelectedCategory.length - 1];

                targetElement.after(...movingBlock);

                // reset positions on all siblings from where we will move the category
                const fromSiblings = [...placeholder.querySelectorAll('[data-parent-id="' + (row.dataset.parentId || '') + '"][data-depth="' + row.dataset.depth +'"]')];
                let fromPosition = 0;
                fromSiblings.forEach(sibling => {
                    ++fromPosition;
                    sibling.dataset.position = fromPosition;
                });

                this.data.rearrange({items: getOrderedCategories()}).then(results => {
                    modal.close();

                    if (results.status === 'success' && !results.error) {
                        showSnackbar(__('text_saved_successful'), 'success');
                    } else {
                        placeholder.querySelector('.card__content').replaceChildren(...snapshot);
                        if (!results.hasOwnProperty("display")) {
                            showSnackbar(__('categories.text_failed_revert_to_original'), 'error');
                        }
                    }
                });
            }, {signal});
        });

        modal.open(__('categories.title_move_to'));
    }

    spaceScheduledForDeletionInfo(target) {
        const modal = new Modal('confirm,modal--medium-size');
        modal.onOpen('confirm-template', (body, signal) => {
            body.querySelector('#modal-close').remove();
            const successBtn = body.querySelector('.button--success');
            successBtn.classList.remove('button--disabled');
            successBtn.textContent = 'Got it';

            const el = target.closest('#space-scheduled-for-deletion-details')

            const ownerName = el.dataset.ownerName;
            const scheduledTime = dateFormat(el.dataset.scheduledTime);
            body.querySelector('p').innerHTML = `
The space owner, <strong class="available">${ownerName}</strong>, has initiated their account deletion process. As a result, this space is scheduled for removal on <strong class="warning">${scheduledTime}</strong>.

After this date, you will no longer have access to the space, and all associated data - including transactions of any type you have created - will be permanently deleted.

We highly recommend backing up any essential transaction history.`;

            successBtn.addEventListener('click', e => {
                modal.close();
            }, {signal});

        });

        modal.open('Space deletion scheduled');
    }

    modalHelp(target) {
        const modal = new Modal('confirm,modal--info,modal--medium-size');
        modal.onOpen('confirm-template', (body, signal) => {
            body.querySelector('#modal-close').remove();
            const successBtn = body.querySelector('.button--success');
            successBtn.classList.remove('button--disabled');
            successBtn.textContent = __('info.cta_got_it');

            const translate = __('info.text_' + target.closest('[data-modal-help]').dataset.modalHelp);

            body.querySelector('.modal__body').innerHTML = translate.replace(
                /#number_format#(\d+(?:\.\d+)?)/g,
                (_, amount) => numberFormat(Number(amount))
            );

            successBtn.addEventListener('click', e => {
                modal.close();
            }, {signal});

        });

        modal.open( __('info.title_' + target.closest('[data-modal-help]').dataset.modalHelp));
    }

    deleteSpace(target) {
        const modal = new Modal('confirm,modal--medium-size');
        modal.onOpen('confirm-template', (body, signal) => {
            const cancelBtn = body.querySelector('#modal-close');
            cancelBtn.textContent = __('cta_cancel');
            const deleteBtn = body.querySelector('.button--success');
            deleteBtn.classList.replace('button--success', 'button--danger');
            deleteBtn.classList.remove('button--disabled');
            deleteBtn.textContent = __('cta_delete');

            body.querySelector('p').innerHTML = __('spaces.text_deletion');

            deleteBtn.addEventListener('click', () => {
                this.data.deleteSpace(target.closest('.container').querySelector('input[name="space_id"]').value).then((result) => {
                    modal.close();

                    if (result.status === 'success' && !result.error) {
                        showSnackbar(__('text_saved_successful'), 'success', '/' + SYSTEM_LANGUAGE + '/spaces');
                    }
                });
            }, {signal});
        });

        modal.open(__('title_are_you_sure'));
    }

    addFAQ(target) {
        const modal = new Modal('faq,modal--big-size');
        modal.onOpen('faq-template', (body, signal) => {
            const textarea = body.querySelector('textarea');
            const input = body.querySelector('input[name="question"]');
            const cancelBtn = body.querySelector('#modal-close');
            const saveBtn = body.querySelector('.button--success');
            saveBtn.textContent = __('cta_create');
            cancelBtn.textContent = __('cta_cancel');

            const section = 'help.title_faq_getting_started';
            const dropdown = body.querySelector('.dropdown');
            const dropdownSelected = dropdown.querySelector('.dropdown__selected');
            const dropdownContent = dropdown.querySelector('.dropdown__content');
            const dropdownItem = dropdown.querySelector('.dropdown__item');

            dropdown.querySelector('input').value = section;

            dropdown.querySelector('input').addEventListener('input', e => {
                saveBtn.classList.remove('button--disabled');
            });

            dropdownSelected.dataset.value = section;
            dropdownSelected.querySelector('.text').textContent = __(section);

            EXTRA_DATA.sections.forEach(item => {
                const currentItem = dropdownItem.cloneNode(true);

                currentItem.dataset.value = item.key;
                currentItem.querySelector('.text').textContent = __(item.key);

                dropdownContent.appendChild(currentItem);
            });

            dropdownItem.remove();

            textarea.addEventListener('input', e => {
                if (textarea.value.trim().length) {
                    saveBtn.classList.remove('button--disabled');
                } else {
                    saveBtn.classList.add('button--disabled');
                }
            });

            saveBtn.addEventListener('click', () => {
                this.data.addFAQ({section: dropdown.querySelector('input').value, question: input.value.trim(), answer: textarea.value.trim(), locale: SYSTEM_LANGUAGE}).then((result) => {
                    if (result.status === 'success' && !result.error) {
                        showSnackbar(__('text_saved_successful'), 'success', '/' + SYSTEM_LANGUAGE + '/help/faq');
                    }
                });
            }, {signal});
        });

        modal.open(__('title_creating_faq'));
    }

    editFAQ(target) {
        const modal = new Modal('faq,modal--big-size');
        modal.onOpen('faq-template', (body, signal) => {
            const textarea = body.querySelector('textarea');
            const input = body.querySelector('input[name="question"]');
            const cancelBtn = body.querySelector('#modal-close');
            const saveBtn = body.querySelector('.button--success');
            saveBtn.textContent = __('cta_edit');
            cancelBtn.textContent = __('cta_cancel');

            input.value = target.closest('.card__box').querySelector('.card__header .card__info .text').textContent;

            const content = target.closest('.card__box').querySelector(':scope > .card__content').cloneNode(true);
            content.querySelector('.actions')?.remove();

            textarea.value = content.innerHTML.trim();

            const section = target.closest('[data-key]').dataset.key;
            const dropdown = body.querySelector('.dropdown');
            const dropdownSelected = dropdown.querySelector('.dropdown__selected');
            const dropdownContent = dropdown.querySelector('.dropdown__content');
            const dropdownItem = dropdown.querySelector('.dropdown__item');

            dropdown.querySelector('input').value = section;

            dropdown.querySelector('input').addEventListener('input', e => {
                saveBtn.classList.remove('button--disabled');
            });

            dropdownSelected.dataset.value = section;
            dropdownSelected.querySelector('.text').textContent = __(section);

            EXTRA_DATA.sections.forEach(item => {
                const currentItem = dropdownItem.cloneNode(true);

                currentItem.dataset.value = item.key;
                currentItem.querySelector('.text').textContent = __(item.key);

                dropdownContent.appendChild(currentItem);
            });

            dropdownItem.remove();

            input.addEventListener('input', e => {
                if (input.value.trim().length) {
                    saveBtn.classList.remove('button--disabled');
                } else {
                    saveBtn.classList.add('button--disabled');
                }
            });

            textarea.addEventListener('input', e => {
                if (textarea.value.trim().length) {
                    saveBtn.classList.remove('button--disabled');
                } else {
                    saveBtn.classList.add('button--disabled');
                }
            });

            saveBtn.addEventListener('click', () => {
                this.data.editFAQ(target.closest('.card__box').dataset.id, {section: dropdown.querySelector('input').value, question: input.value.trim(), answer: textarea.value.trim(), locale: SYSTEM_LANGUAGE}).then((result) => {
                    if (result.status === 'success' && !result.error) {
                        showSnackbar(__('text_saved_successful'), 'success', '/' + SYSTEM_LANGUAGE + '/help/faq');
                    }
                });
            }, {signal});
        });

        modal.open(__('title_editing_faq'));
    }

    deleteFAQ(target) {
        const modal = new Modal('confirm,modal--medium-size');
        modal.onOpen('confirm-template', (body, signal) => {
            const cancelBtn = body.querySelector('#modal-close');
            cancelBtn.textContent = __('cta_cancel');
            const deleteBtn = body.querySelector('.button--success');
            deleteBtn.classList.replace('button--success', 'button--danger');
            deleteBtn.classList.remove('button--disabled');
            deleteBtn.textContent = __('cta_yes');

            const item = target.closest('.card__box').querySelector('.card__header .text').textContent;
            body.querySelector('p').innerHTML = `You're about to delete <b>${item}</b>, do you want to proceed?`;

            deleteBtn.addEventListener('click', () => {
                this.data.deleteFAQItem(target.closest('[data-id]').dataset.id).then((result) => {
                    modal.close();

                    if (result.status === 'success' && !result.error) {
                        showSnackbar(__('text_saved_successful'), 'success', '/' + SYSTEM_LANGUAGE + '/help/faq');
                    }
                });
            }, {signal});
        });

        modal.open(__('title_are_you_sure'));
    }
}